import * as TYPES from './type';
export default {
  // 学生学习进度
  [TYPES.STU_LEARNINGPROGRESS](state, { result }) {
    state.StuLearningProgress = result.result
  },
  // 活动参与情况
  [TYPES.STU_ACTIVITYTAKE](state, { result }) {
    state.stuActivityTake = result.result
  },
  // 活动组织次数
  [TYPES.STU_ACTIVITYTIME](state, { result }) {
    state.stuActivitytime = result.result
  },
  // 考勤预警
  [TYPES.STU_ATTENDANCE](state, { result }) {
    state.stuAttendance = result.result
  },
  // 预习预警
  [TYPES.STU_PREPAREWARNING](state, { result }) {
    state.stuPrepareWarning = result.result
  },
  // 作业预警
  [TYPES.STU_JOBWARNING](state, { result }) {
    state.stuJobWarning = result.result
  },
  // 活动预警
  [TYPES.STU_ACTIVITYWARNING](state, { result }) {
    state.stuActivityWarning = result.result
  },
  // 过程性评价
  [TYPES.STU_EVALUATE](state, { result }) {
    state.stuEvaluate = result.result
  },
  // 教学明细表
  [TYPES.STU_TEACHDETAIL](state, { result }) {
    state.stuTeachDetail = result.result
  },
  // 教学明细表
  [TYPES.STU_INFORMATION](state, { result }) {
    state.stuHeadrInformation = result.result
  },
}


// WEBPACK FOOTER //
// ./src/store/effect/mutations.js